import { ColumnType } from "antd/es/table"
import { IProjectData } from "../types/projectData.types"
import Product from "../components/Product"

const useProjectDataColumns = (projectData: IProjectData[]) => {
  console.log(projectData)
  const columns: ColumnType<IProjectData>[] = [
    {
      title: `Product (${projectData.length})`,
      key: "asin",
      width: "60%",
      render: (asin: IProjectData) => <Product asin={asin} />,
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
      render: (price: number) => `$${price}`,
    },
  ]

  return columns
}

export default useProjectDataColumns
